<template>
  <div class="upload-image">
    <label for="file-upload" class="file-upload-label">
      <div class="avatar-placeholder" v-if="!imageSrc && !clientImage">
        <img
          src="@/assets/images/avatar/avatar.png"
          alt="Avatar"
          class="avatar-placeholder-image"
        />
        <p class="upload-text">Upload Picture</p>
      </div>
      <img
        v-else
        :src="imageSrc ? imageSrc : clientImage"
        alt="Uploaded Image"
        class="avatar-image"
      />
    </label>
    <input
      id="file-upload"
      type="file"
      @change="onChange"
      class="file-input"
    />
    <div class="remove-button">
      <button v-if="imageSrc || clientImage" @click="removeImage">X</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientImage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageSrc: null,
      imageUrl: null,
    };
  },
  methods: {
    onFileChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.imageSrc = reader.result;
      };
      const file = event.target.files ? event.target.files[0] : null;
      if (file && file.type.startsWith("image/")) {
        this.imageUrl = file;
        this.$emit("image-selected", this.imageUrl);
      } else {
        alert("Please select a valid image file.");
        this.imageUrl = null;
      }
    },
    onChange(event) {
      this.onFileChange(event);
    },
    removeImage() {
      this.$emit("remove-image");
      this.imageSrc = null;
      this.imageUrl = null;
      document.getElementById("file-upload").value = null;
    },
  },
};
</script>

<style scoped>
.upload-image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  position: relative;
}

.file-upload-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border: 2px dashed #ccc;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.file-upload-label:hover {
  border-color: #888;
}

.avatar-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avatar-placeholder-image {
  max-width: 50%;
  max-height: 50%;
  border-radius: 50%;
  margin-bottom: 10px;
}

.avatar-image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10%;
}

.upload-text {
  font-size: 12px;
  color: #555;
  text-align: center;
}

.file-input {
  display: none;
}

.remove-button {
  position: relative;
}
.remove-button button {
  position: absolute;
  top: -62px;
  left: -12px;
  background-color: #ff6666;
  border: none;
  border-radius: 50%;
  color: white;
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s;
}

.remove-button:hover {
  background-color: #ff3333;
}
</style>
